module.exports = __webpack_public_path__ + "img/SecondClass.17942127.jpg";